export default "__VITE_ASSET__CHrFkxvI__"